import { useEffect, useState } from "react";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import TabHeader from "@/components/admin/TabHeader";
import ImageListEditor from "@/components/admin/ImageListEditor";
import { field } from "@/pages/admin/AdminLogin";

function RoomCard({ room, onSaved }) {
  const [r, setR] = useState(room);
  const dirty = JSON.stringify(r) !== JSON.stringify(room);
  const save = async () => {
    try { await api.put(`/admin/categories/${room.id}`, r); toast.success(`${r.title} saved`); onSaved(); } catch (e) { toast.error(errMsg(e)); }
  };
  const del = async () => {
    if (!window.confirm(`Delete the room “${room.title}”?`)) return;
    try { await api.delete(`/admin/categories/${room.id}`); onSaved(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div data-testid={`admin-room-${room.id}`} className="flex flex-col gap-4 bg-paper p-5 sm:flex-row">
      <ImageListEditor images={r.cover ? [r.cover] : []} max={1} onChange={(imgs) => setR({ ...r, cover: imgs[0] || "" })} testid={`room-cover-${room.id}`} />
      <div className="flex-1 space-y-3">
        <input data-testid={`room-title-${room.id}`} value={r.title} onChange={(e) => setR({ ...r, title: e.target.value })} className={field} />
        <textarea data-testid={`room-note-${room.id}`} rows={3} value={r.note} onChange={(e) => setR({ ...r, note: e.target.value })} className={field} />
        <div className="flex justify-between">
          {room.id !== "ready" ? <button type="button" onClick={del} className="font-body text-xs text-muted hover:text-red-700">Delete room</button> : <span className="font-body text-xs text-muted">Shows every ready-to-wear piece automatically</span>}
          <button type="button" data-testid={`room-save-${room.id}`} disabled={!dirty || !r.cover} onClick={save} className="bg-ink px-5 py-2.5 text-paper disabled:opacity-30"><span className="overline">Save</span></button>
        </div>
      </div>
    </div>
  );
}

export default function RoomsTab() {
  const [rooms, setRooms] = useState([]);
  const load = () => api.get("/store/catalog").then((r) => setRooms(r.data.categories));
  useEffect(() => { load(); }, []);

  const add = async () => {
    const title = window.prompt("Name of the new room (e.g. Bags)");
    if (!title) return;
    try { await api.post("/admin/categories", { title, note: "", cover: "", sort: rooms.length }); load(); } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div data-testid="admin-rooms-tab">
      <TabHeader title="Rooms" note="The boutique’s collection rooms — change each room’s cover photo, name and short description.">
        <button type="button" data-testid="admin-room-new" onClick={add} className="inline-flex items-center gap-2 bg-ink px-5 py-3 text-paper"><Plus className="h-4 w-4" /><span className="overline">New room</span></button>
      </TabHeader>
      <div className="grid gap-4 xl:grid-cols-2">{rooms.map((r) => <RoomCard key={r.id + (r.cover || "")} room={r} onSaved={load} />)}</div>
    </div>
  );
}
